import Vue from 'vue';

const state = {
	featureFlags: {},
    featureFlagsLoading: false,
    featureFlagsLoaded: false
};

const getters = {
	isFeatureEnabled: (state) => (featureName) => {
		if (!state.featureFlagsLoaded) return false;

        return state.featureFlags[featureName];
    }
};

const actions = {
	getFeatureFlags({ commit, rootState }) {
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/featureFlags`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	enableFeature({ commit, rootState }, featureName) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/featureFlags/toggle/${featureName}`, { status: true })
				.then(resp => {
					commit('FEATURE_ENABLED', featureName);
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
	disableFeature({ commit, rootState }, featureName) {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/featureFlags/toggle/${featureName}`, { status: false })
				.then(resp => {
					commit('FEATURE_DISABLED', featureName);
					resolve(resp);
				})
				.catch(err => {
					reject(err);
				});
		});
	},
};

const mutations = {
	GET_PENDING(state) {
		state.featureFlagsLoading = true;
	},
	GET_SUCCESS(state, data) {
		state.featureFlagsLoading = false;
        state.featureFlagsLoaded = true;
		state.featureFlags = data;
	},
	GET_FAILURE(state, error) {
		state.featureFlagsLoading = false;
	},
	FEATURE_ENABLED(state, featureName) {
		if (state.featureFlags.hasOwnProperty(featureName)) {
			state.featureFlags[featureName] = true;
		}
	},
	FEATURE_DISABLED(state, featureName) {
		if (state.featureFlags.hasOwnProperty(featureName)) {
			state.featureFlags[featureName] = false;
		}
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
